import { APPLICATION_IDS } from "./applications";
import { classifications } from "./classifications";
import { createRequestData } from "./createCase";
import { mockMachines } from "./machine";
import { NOTIFICATION_TYPES } from "./notificationType";
import { SALUTATION } from "./salutation";
import { mockSoftwares } from "./software";

const uuid = "15f9a89a-f313-473a-80a2-ae467fbb63fc";

describe("createRequestData", () => {
    it("should return the correct data", () => {
        const form: HTMLFormElement = {
            notificationType: { value: String(NOTIFICATION_TYPES.MACHINE_STOP) },
            description: { value: "Lorem ipsum" },
            salutation: { value: SALUTATION.FEMALE },
            firstName: { value: "Marie" },
            lastName: { value: "Curie" },
            phone: { value: "0049123123123" },
            email: { value: "m@c.de" },
            productNo: { value: String(mockMachines[0].productNo) },
            softwareType: { value: mockSoftwares[0].softwareType },
            softwareModule: { value: mockSoftwares[0].softwareModule },
            installationProblem: { checked: true },
            licenseIssue: { checked: false },
            softwareProblemClassification: { value: classifications[0] },
            /** @ts-ignore */
            querySelectorAll: () => [{ value: "errorNumber1" }, { value: "123.123" }] as unknown,
            application: { value: APPLICATION_IDS.WELDING },
            optics: { value: APPLICATION_IDS.FIXED_OPTICS_BEO },
            applicationIssue: { value: APPLICATION_IDS.WELD_DEPTH }
        } as unknown as HTMLFormElement;
        const data = createRequestData({
            form,
            callId: uuid,
            createdWith: "something",
            softwares: mockSoftwares,
            machines: mockMachines
        });

        expect(data).toEqual({
            callId: uuid,
            createdWith: "something",
            notificationType: NOTIFICATION_TYPES.MACHINE_STOP,
            description: "Lorem ipsum",
            callBackContact: {
                salutation: SALUTATION.FEMALE,
                firstName: "Marie",
                lastName: "Curie",
                phone: "0049123123123",
                email: "m@c.de"
            },
            equipmentNo: String(mockMachines[0].productNo),
            hmiErrorsWithInfo: [
                { errorNumber: "errorNumber1", errorSource: "UNDEFINED" },
                { errorNumber: "123.123", errorSource: "MMC" }
            ],
            software: {
                productNumber: String(mockSoftwares[0].productNo),
                softwareModule: String(mockSoftwares[0].softwareModule),
                softwareType: String(mockSoftwares[0].softwareType),
                isInstallationProblem: true,
                isLicenseIssue: false,
                softwareProblemClassification: classifications[0]
            },
            applicationTopicOptions: [APPLICATION_IDS.WELDING, APPLICATION_IDS.FIXED_OPTICS_BEO, APPLICATION_IDS.WELD_DEPTH],
            purchaseOrderNumber: null,
            additionalText: null
        });
    });
});
